import get from 'lodash/get';
import Plausible from 'plausible-tracker';
import config from '../config/index';
import { getFullUserPhoneFromUser } from './user.path';

const events = [
  'closedListings',
  'notListingVerifiedNumbers',
  'listingVerifiedNumbers',
  'notVerifiedNumbers',
  'verifiedNumbers',
  'aircraftListingType',
  'sellerAccounts',
];

export const plausibleGoals = Object.fromEntries(events.map(event => [event, event]));

export const plausible = Plausible({domain: config.plausibleDomain});

export const { trackEvent} = plausible;

export const trackEventsOnPublishListing = listing => {
  const listing_phone_number = get(listing, 'attributes.publicData.listing_phone_number', null);

  if(listing_phone_number) {
    trackEvent(plausibleGoals.listingVerifiedNumbers)
  } else {
    trackEvent(plausibleGoals.notListingVerifiedNumbers)
  }
  trackEvent(plausibleGoals.aircraftListingType);
}

export const trackEventsVerifiedNumbers = (user, phoneValue) => {
  const phoneNumberObj = getFullUserPhoneFromUser(user, phoneValue);

  phoneNumberObj.isVerified
    ? trackEvent(plausibleGoals.verifiedNumbers)
    : trackEvent(plausibleGoals.notVerifiedNumbers)
  ;
}
